import { render, staticRenderFns } from "./peripheryComparison.vue?vue&type=template&id=996fccf4&scoped=true&"
import script from "./peripheryComparison.vue?vue&type=script&lang=js&"
export * from "./peripheryComparison.vue?vue&type=script&lang=js&"
import style0 from "./peripheryComparison.vue?vue&type=style&index=0&id=996fccf4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "996fccf4",
  null
  
)

export default component.exports